<p-panel header="Finished goods" [toggleable]="true">
  <div class="p-2">
    <div class="align-items-center d-flex col-lg-12 mb-3">
      <div class="nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="addNewService()"
          ><i class="pi pi-plus"></i> New</a
        >
      </div>

      <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <div>
          <a class="link delcol" (click)="onRowDelete()"
            ><i class="pi pi-trash"></i> Delete</a
          >
        </div>
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="onCopyLines()"
          ><i class="pi pi-copy"></i> Copy Lines</a
        >
      </div>
    </div>

    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="350px"
      [size]="'small'"
      [resizableColumns]="true"
      [value]="filteredFinishedGoodsList"
      [(selection)]="selectedGoods"
      styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      dataKey="portalKeyD365"
      editMode="row"
      selectionMode="multiple"
      [scrollable]="true"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <!-- <th style="width: 3rem"></th> -->
          <th></th>
          <th class="col-center">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="vendor-sku">Item Number</th>
          <th class="description colwdth-large width-220">Description</th>
          <!-- <th class="description">Product Name</th> -->
          <!-- <th class="quantity">Configuration</th> -->
          <th class="sell-total">Color</th>
          <th class="net">Style</th>
          <th class="sell">Size</th>
          <!-- <th class="net">Physical Inventory</th> -->
          <th class="net">Quantity</th>
          <th class="net">Unit</th>
          <th class="net">Sell</th>
          <th class="net">Sell Total</th>
          <th class="net">Net</th>
          <th class="net">Net Total</th>
          <th class="net">Available Physical</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-finishedGoods
        let-editing="editing"
        let-ri="rowIndex"
        let-rowIndex="rowIndex">
        <ng-container>
          <tr
            [pReorderableRow]="rowIndex"
            class="p-selectable-row"
            [pEditableRow]="finishedGoods"
            [pSelectableRow]="finishedGoods"
            class="finished-good">
            <!-- <td>
              <span
                class="pi pi-bars"
                [pReorderableRowHandle]="rowIndex"
              ></span>
            </td> -->
            <td style="text-align: center">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text"
                (click)="
                  onEditRow(finishedGoods.portalKeyD365, finishedGoods)
                "></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"
                (click)="onRowEditSave(finishedGoods)"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"
                (click)="refreshGrid()"></button>
            </td>
            <td class="col-center">
              <p-tableCheckbox
                [pSelectableRow]="finishedGoods"
                [value]="finishedGoods"></p-tableCheckbox>
            </td>
            <td pEditableColumn pEditableColumnField="itemNumberD365">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-select
                    pInputText
                    id="itemNumber"
                    [editable]="editing ? false : true"
                    [(ngModel)]="finishedGoods.itemNumberD365"
                    [options]="releasedProductsList"
                    optionLabel="itemNumberD365"
                    optionValue="itemNumberD365"
                    (onChange)="itemSelected($event, finishedGoods)"
                    [filter]="true"
                    [showClear]="true"
                    appendTo="body">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods?.itemNumberD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="description colwdth-large hoverwdth"
              style="white-space: normal !important"
              [ngClass]="{
                'trimmeddescription trimmedby50char': descriptionCharacterCond,
              }"
              pEditableColumn
              pEditableColumnField="lineDescriptionD365"
              [pTooltip]="finishedGoods.lineDescriptionD365"
              [tooltipOptions]="toolTipOptions">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <textarea
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    [(ngModel)]="finishedGoods.lineDescriptionD365"
                    (keydown)="
                      onTextFieldKeyDown(
                        $event,
                        finishedGoods,
                        'lineDescriptionD365'
                      )
                    "></textarea>
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    descriptionCharacterCount(finishedGoods.lineDescriptionD365)
                  }}
                  {{ finishedGoods.lineDescriptionD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <!-- <td class="description">
              {{ finishedGoods.productNameD365 }}
            </td> -->
            <!-- <td class="sell">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <ng-select
                    
                    id="currency"
                    style="width: auto"
                    [(ngModel)]="finishedGoods.configD365"
                    appendTo="body"
                  >
                    <ng-option *ngFor="let com of filteredConfig" [value]="com">
                      {{ com }}
                    </ng-option>
                  </ng-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.configD365 }}
                </ng-template>
              </p-cellEditor>
            </td> -->
            <td
              class="net"
              pEditableColumn
              pEditableColumnField="colorD365"
              (click)="
                setSizeAndColor(
                  finishedGoods.itemNumberD365 || '',
                  finishedGoods
                )
              ">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-select
                    [editable]="editing ? false : true"
                    id="color"
                    [(ngModel)]="finishedGoods.colorD365"
                    (onClear)="generateDescription(finishedGoods)"
                    (onChange)="generateDescription(finishedGoods)"
                    [options]="filteredColors"
                    [filter]="true"
                    appendTo="body"
                    [showClear]="true">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.colorD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="net"
              pEditableColumn
              pEditableColumnField="styleD365"
              (click)="
                setSizeAndColor(
                  finishedGoods.itemNumberD365 || '',
                  finishedGoods
                )
              ">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-select
                    pInputText
                    id="style"
                    [editable]="editing ? false : true"
                    [(ngModel)]="finishedGoods.styleD365"
                    [options]="filteredStyles"
                    (onClear)="generateDescription(finishedGoods)"
                    (onChange)="generateDescription(finishedGoods)"
                    [filter]="true"
                    appendTo="body"
                    [showClear]="true">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.styleD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="sell"
              pEditableColumn
              pEditableColumnField="sizeD365"
              (click)="
                setSizeAndColor(
                  finishedGoods.itemNumberD365 || '',
                  finishedGoods
                )
              ">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-select
                    id="size"
                    [editable]="editing ? false : true"
                    [(ngModel)]="finishedGoods.sizeD365"
                    [options]="filteredSizes"
                    (onClear)="generateDescription(finishedGoods)"
                    (onChange)="generateDescription(finishedGoods)"
                    [filter]="true"
                    appendTo="body"
                    [showClear]="true">
                  </p-select>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.sizeD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <!-- <td class="net">
              {{ finishedGoods.physicalInventoryD365 }}
            </td> -->

            <td
              class="quantity"
              pEditableColumn
              pEditableColumnField="orderedPurchaseQuantityD365">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    jniAutoCompleteBlocker
                    type="text"
                    [(ngModel)]="finishedGoods.orderedPurchaseQuantityD365"
                    (keydown)="onQuantityKeyDown($event, finishedGoods)"
                    (ngModelChange)="
                      onFocusOut(
                        $event,
                        finishedGoods.orderedPurchaseQuantityD365,
                        finishedGoods
                      )
                    "
                    required
                    (focus)="selectText($event)" />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ finishedGoods.orderedPurchaseQuantityD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="net"
              pEditableColumn
              pEditableColumnField="purchaseUnitSymbolD365">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-select
                    pInputText
                    #currencySelect
                    [editable]="editing ? false : true"
                    [(ngModel)]="finishedGoods.purchaseUnitSymbolD365"
                    [options]="unit"
                    [filter]="true"
                    appendTo="body"
                    [showClear]="true">
                  </p-select>
                </ng-template>
                <ng-template
                  pTemplate="output"
                  [name]="'unit-' + ri"
                  [id]="'unit-' + ri"
                  [inputId]="'unit-' + ri">
                  {{ finishedGoods.purchaseUnitSymbolD365 }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td
              class="quantity"
              pEditableColumn
              pEditableColumnField="mockSellD365">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    [(ngModel)]="finishedGoods.mockSellD365"
                    (keydown)="onMockSellKeyDown($event, finishedGoods)"
                    (ngModelChange)="
                      calculateMockSellTotal(
                        finishedGoods.mockSellD365,
                        finishedGoods
                      )
                    "
                    (focus)="selectText($event)"
                    required />
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    finishedGoods.mockSellD365
                      | currency: "USD" : "symbol" : "0.4-4"
                  }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="quantity">
              {{
                finishedGoods?.mockSellTotalD365
                  | currency: "USD" : "symbol" : "0.4-4"
              }}
            </td>
            <td class="quantity">
              {{
                finishedGoods.purchasePriceD365
                  | currency
                    : getCurrencyConvertionCode(
                        finishedGoods?.currencyCodeD365 || ""
                      )
                    : "symbol"
                    : "0.4-4"
              }}
            </td>
            <td class="ntotal">
              {{
                finishedGoods.lineAmountD365
                  | currency
                    : getCurrencyConvertionCode(
                        finishedGoods?.currencyCodeD365 || ""
                      )
                    : "symbol"
                    : "0.2-2"
              }}
            </td>
            <td class="net">
              {{ finishedGoods.physicalAvailableD365 }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20" class="colwdth-large nofound">
            No line item found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-panel>
